import { createContext, useState, useEffect } from 'react'
import { IFeature } from 'interfaces'
import { api } from 'helpers'

interface FeatureToggleContextType {
  features: IFeature[]
  setFeatures: (features: IFeature[]) => void
  isLoading: boolean
}

export const FeatureToggleContext = createContext<FeatureToggleContextType>({
  features: [],
  setFeatures: () => {},
  isLoading: true,
})

export const FeatureToggleProvider = ({ children }: { children: React.ReactNode }) => {
  const [features, setFeatures] = useState<IFeature[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Only fetch if we haven't loaded features yet and are still in loading state
    if(features?.length === 0 && isLoading) {
      const fetchFeatures = async () => {
        try {
          const response = await api.get('/api/arc_mosaico/features/current')
          setFeatures(response.data.features)
        } catch (error) {
          console.error('Failed to fetch feature flags:', error)
          // Set empty array on error to prevent undefined state
          setFeatures([])
        } finally {
          setIsLoading(false)
        }
      }
      fetchFeatures()
    }
  }, [features, isLoading])

  return (
    <FeatureToggleContext.Provider
      value={{
        features,
        setFeatures,
        isLoading,
      }}
    >
      {children}
    </FeatureToggleContext.Provider>
  )
}
